module.exports = __webpack_public_path__ + "img/relevance.f75daee4.svg";